import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Layout from '../Layout';
import { fetchPaymentsList, clearMessage, getSubscriptionStatus } from '../../../redux/slices/customer/paymentsSlice';
import Pagination from '../../../components/common/Pagination';
 
 
import '../../../global.css';
import './styles.css';
import PaymentForm from './PaymentForm';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import showAlert from '../../../components/common/showAlert';
import api from '../../../api';
import Back from '../../../components/common/Back';

 

const Payments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { totalPages, currentPage, payments_list, subscription_status } = useSelector((state) => state.customer_payments);
  const [activeTab, setActiveTab] = useState('account');
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageIsLoading, setpageIsLoading] = useState(true);

  useEffect(() => {
    dispatch(clearMessage());
    dispatch(getSubscriptionStatus());
    dispatch(fetchPaymentsList(1));
  }, [dispatch]);

  const { userType } = useSelector((state) => state.apiResponses);

  useEffect(() => {
    if (userType == '1') {
      navigate('/meal-plan');
    } else {
      setpageIsLoading(false);
    }
  }, [userType]); 

  const handlePageChange = (page) => {
    dispatch(fetchPaymentsList(page));
  };

  const handleSubscribe = () => {
    setShowModal(true);
  };

  const handleCancelSubscriptionConfirm = () => {
    confirmAlert({
      title: 'Confirm Cancellation',
      message: 'Are you sure you want to cancel current subscription?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => handleCancelSubscription()
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  }

  const handleCancelSubscription = async () => {
    setIsLoading(true);
     try {
        const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/cancel-subscription`);
        const data = response.data;
        if (data.success) {
           showAlert('success', 'Subscription has been cancelled successfully!');
        } else {
          alert(`Operation failed: ${data.message}`);
        }
        dispatch(clearMessage());
        dispatch(getSubscriptionStatus());
        dispatch(fetchPaymentsList(1));
        setIsLoading(false);
      } catch (err) {
        alert('Error processing payment.');
        setIsLoading(false);
      }
  };

  if (pageIsLoading) {
    return null;
  }

  return (    
    <Layout>
      <h1>Payment not available</h1>
    </Layout>
    
  );
};
export default Payments;